import { SlidersHorizontal } from 'lucide-react';
import { FC } from 'react';

interface FiltersButtonProps {
  onClick: () => void;
  isActive?: boolean;
  title?: string;
}

const FiltersButton: FC<FiltersButtonProps> = ({
  onClick,
  isActive = false,
  title = 'Filtros'
}) => (
  <button
    type="button"
    title={title}
    onClick={onClick}
    className={
      'inline-flex h-9 w-9 items-center justify-center rounded-full transition hover:scale-110 ' +
      (isActive
        ? 'bg-secondary-50 text-secondary-600 dark:bg-white/10 dark:text-secondary-300'
        : 'text-inkMuted hover:text-secondary-600 dark:text-inkMuted-dark dark:hover:text-secondary-300')
    }
  >
    <SlidersHorizontal size={18} />
  </button>
);

export default FiltersButton;
